import React, { useEffect } from 'react'
import { Box, Text } from 'grommet'
import { PacmanLoader } from 'react-spinners'
import { qlikBrand } from '../../branding'
import CreateBugfix from '../../components/CreateBugfix'
import { useRepositories } from '../../hooks'

function AddBugfixProject() {
  const { fetchRepositories, fetchRepositoriesInProgress, repositories } = useRepositories()

  useEffect(() => {
    fetchRepositories()
  }, [fetchRepositories])

  return (
    <Box margin='medium'>
      {fetchRepositoriesInProgress ? (
        <Box align='center' pad='large' gap='medium'>
          <PacmanLoader
            loading={true}
            color={qlikBrand.core.green}
            size={50}
          />
          <Text size='large'>Fetching repositories...</Text>
        </Box>
      ) : (
        <CreateBugfix />
      )}
    </Box>
  )
}

export default AddBugfixProject
